__turbopack_context__.v({
  "aiAvatar": "HowItWorksMock-module__2n3poW__aiAvatar",
  "aiBar": "HowItWorksMock-module__2n3poW__aiBar",
  "aiBody": "HowItWorksMock-module__2n3poW__aiBody",
  "aiCard": "HowItWorksMock-module__2n3poW__aiCard",
  "aiStatus": "HowItWorksMock-module__2n3poW__aiStatus",
  "aiTab": "HowItWorksMock-module__2n3poW__aiTab",
  "aiTabActive": "HowItWorksMock-module__2n3poW__aiTabActive",
  "aiTabIcon": "HowItWorksMock-module__2n3poW__aiTabIcon",
  "aiTabs": "HowItWorksMock-module__2n3poW__aiTabs",
  "aiTurn": "HowItWorksMock-module__2n3poW__aiTurn",
  "answerText": "HowItWorksMock-module__2n3poW__answerText",
  "askBar": "HowItWorksMock-module__2n3poW__askBar",
  "askIcon": "HowItWorksMock-module__2n3poW__askIcon",
  "askPlaceholder": "HowItWorksMock-module__2n3poW__askPlaceholder",
  "askSend": "HowItWorksMock-module__2n3poW__askSend",
  "askText": "HowItWorksMock-module__2n3poW__askText",
  "avatar": "HowItWorksMock-module__2n3poW__avatar",
  "badge": "HowItWorksMock-module__2n3poW__badge",
  "bar": "HowItWorksMock-module__2n3poW__bar",
  "barFill": "HowItWorksMock-module__2n3poW__barFill",
  "barLabel": "HowItWorksMock-module__2n3poW__barLabel",
  "barTrack": "HowItWorksMock-module__2n3poW__barTrack",
  "barValue": "HowItWorksMock-module__2n3poW__barValue",
  "brandClaude": "HowItWorksMock-module__2n3poW__brandClaude",
  "brandOpenAI": "HowItWorksMock-module__2n3poW__brandOpenAI",
  "card": "HowItWorksMock-module__2n3poW__card",
  "caret": "HowItWorksMock-module__2n3poW__caret",
  "caretBlink": "HowItWorksMock-module__2n3poW__caretBlink",
  "chart": "HowItWorksMock-module__2n3poW__chart",
  "checkbox": "HowItWorksMock-module__2n3poW__checkbox",
  "chip": "HowItWorksMock-module__2n3poW__chip",
  "cite": "HowItWorksMock-module__2n3poW__cite",
  "criteria": "HowItWorksMock-module__2n3poW__criteria",
  "criteriaMore": "HowItWorksMock-module__2n3poW__criteriaMore",
  "criterion": "HowItWorksMock-module__2n3poW__criterion",
  "criterionKey": "HowItWorksMock-module__2n3poW__criterionKey",
  "criterionValue": "HowItWorksMock-module__2n3poW__criterionValue",
  "customerName": "HowItWorksMock-module__2n3poW__customerName",
  "dot": "HowItWorksMock-module__2n3poW__dot",
  "dotField": "HowItWorksMock-module__2n3poW__dotField",
  "dotKept": "HowItWorksMock-module__2n3poW__dotKept",
  "dotObjection": "HowItWorksMock-module__2n3poW__dotObjection",
  "dotPain": "HowItWorksMock-module__2n3poW__dotPain",
  "dotSignal": "HowItWorksMock-module__2n3poW__dotSignal",
  "dots": "HowItWorksMock-module__2n3poW__dots",
  "draft": "HowItWorksMock-module__2n3poW__draft",
  "draftHead": "HowItWorksMock-module__2n3poW__draftHead",
  "draftSubject": "HowItWorksMock-module__2n3poW__draftSubject",
  "event": "HowItWorksMock-module__2n3poW__event",
  "eventBody": "HowItWorksMock-module__2n3poW__eventBody",
  "eventHead": "HowItWorksMock-module__2n3poW__eventHead",
  "eventItem": "HowItWorksMock-module__2n3poW__eventItem",
  "eventNode": "HowItWorksMock-module__2n3poW__eventNode",
  "eventNodeAi": "HowItWorksMock-module__2n3poW__eventNodeAi",
  "fieldDot": "HowItWorksMock-module__2n3poW__fieldDot",
  "fieldDotKept": "HowItWorksMock-module__2n3poW__fieldDotKept",
  "group": "HowItWorksMock-module__2n3poW__group",
  "howPulse": "HowItWorksMock-module__2n3poW__howPulse",
  "identity": "HowItWorksMock-module__2n3poW__identity",
  "itemAside": "HowItWorksMock-module__2n3poW__itemAside",
  "itemText": "HowItWorksMock-module__2n3poW__itemText",
  "label": "HowItWorksMock-module__2n3poW__label",
  "legendDot": "HowItWorksMock-module__2n3poW__legendDot",
  "legendTag": "HowItWorksMock-module__2n3poW__legendTag",
  "lost": "HowItWorksMock-module__2n3poW__lost",
  "meta": "HowItWorksMock-module__2n3poW__meta",
  "metrics": "HowItWorksMock-module__2n3poW__metrics",
  "open": "HowItWorksMock-module__2n3poW__open",
  "overdue": "HowItWorksMock-module__2n3poW__overdue",
  "processing": "HowItWorksMock-module__2n3poW__processing",
  "processingDot": "HowItWorksMock-module__2n3poW__processingDot",
  "prompt": "HowItWorksMock-module__2n3poW__prompt",
  "queries": "HowItWorksMock-module__2n3poW__queries",
  "query": "HowItWorksMock-module__2n3poW__query",
  "row": "HowItWorksMock-module__2n3poW__row",
  "rowLive": "HowItWorksMock-module__2n3poW__rowLive",
  "rowName": "HowItWorksMock-module__2n3poW__rowName",
  "rowTexts": "HowItWorksMock-module__2n3poW__rowTexts",
  "rows": "HowItWorksMock-module__2n3poW__rows",
  "sectionHead": "HowItWorksMock-module__2n3poW__sectionHead",
  "source": "HowItWorksMock-module__2n3poW__source",
  "sourceName": "HowItWorksMock-module__2n3poW__sourceName",
  "sourceTile": "HowItWorksMock-module__2n3poW__sourceTile",
  "sources": "HowItWorksMock-module__2n3poW__sources",
  "stack": "HowItWorksMock-module__2n3poW__stack",
  "stackAvatar": "HowItWorksMock-module__2n3poW__stackAvatar",
  "status": "HowItWorksMock-module__2n3poW__status",
  "statusDot": "HowItWorksMock-module__2n3poW__statusDot",
  "summary": "HowItWorksMock-module__2n3poW__summary",
  "tag": "HowItWorksMock-module__2n3poW__tag",
  "tagMore": "HowItWorksMock-module__2n3poW__tagMore",
  "talkBar": "HowItWorksMock-module__2n3poW__talkBar",
  "talkFill": "HowItWorksMock-module__2n3poW__talkFill",
  "theme": "HowItWorksMock-module__2n3poW__theme",
  "themeMore": "HowItWorksMock-module__2n3poW__themeMore",
  "themeShare": "HowItWorksMock-module__2n3poW__themeShare",
  "themeText": "HowItWorksMock-module__2n3poW__themeText",
  "themes": "HowItWorksMock-module__2n3poW__themes",
  "timeline": "HowItWorksMock-module__2n3poW__timeline",
  "toneNeutral": "HowItWorksMock-module__2n3poW__toneNeutral",
  "toneObjection": "HowItWorksMock-module__2n3poW__toneObjection",
  "tonePain": "HowItWorksMock-module__2n3poW__tonePain",
  "toneSignal": "HowItWorksMock-module__2n3poW__toneSignal",
  "toolBlock": "HowItWorksMock-module__2n3poW__toolBlock",
  "toolChips": "HowItWorksMock-module__2n3poW__toolChips",
  "toolHead": "HowItWorksMock-module__2n3poW__toolHead",
  "toolMeta": "HowItWorksMock-module__2n3poW__toolMeta",
  "toolScan": "HowItWorksMock-module__2n3poW__toolScan",
  "won": "HowItWorksMock-module__2n3poW__won",
});
